type DynamicMetric = {
  fontSizeUnit: 'rem' | 'px';
  fontSize: number;
  letterSpacing: string;
  lineHeight: string;
};

export type InterUIFontSize = 10 | 13 | 14 | 15 | 16 | 20 |  24 | 30;

export const getInterUIDynamicMetrics = (fontSize: InterUIFontSize): DynamicMetric => {
  switch (fontSize) {
    case 10:
      return { fontSizeUnit: 'px', fontSize: 10, letterSpacing: '0.018em', lineHeight: '14px' };
    case 13:
      return { fontSizeUnit: 'px', fontSize: 13, letterSpacing: '0.004em', lineHeight: '18px' };
    case 14:
      return { fontSizeUnit: 'px', fontSize: 14, letterSpacing: '0em', lineHeight: '20px' };
    case 15:
      return { fontSizeUnit: 'px', fontSize: 15, letterSpacing: '-0.002em', lineHeight: '21px' };
    case 16:
      return { fontSizeUnit: 'px', fontSize: 16, letterSpacing: '-0.005em', lineHeight: '22px' };
    case 24:
      return { fontSizeUnit: 'px', fontSize: 24, letterSpacing: '-0.014em', lineHeight: '34px' };
    case 30:
      return { fontSizeUnit: 'px', fontSize: 30, letterSpacing: '-0.016em', lineHeight: '42px' };

    case 20:
      return { fontSizeUnit: 'px', fontSize: 20, letterSpacing: '-0.017em', lineHeight: '28px' };
    default:
      return { fontSizeUnit: 'px', fontSize: 16, letterSpacing: '-0.005em', lineHeight: '22px' };
  }
};

export const getInterUIDynamicMetricCssObject = (opticalFontSize: InterUIFontSize, as: 'rem' | 'px' = 'px') => {
  const { fontSize, letterSpacing, lineHeight } = getInterUIDynamicMetrics(opticalFontSize);

  return {
    fontFamily: 'Inter UI',
    fontSize,
    letterSpacing,
    lineHeight
  };
};
